import { ActionType, BaseActionWidget, FormSubviewFieldWidget, ReloadViewActionWidget, RuntimeContext, RuntimeModel, SPI, UrlActionWidget, ViewType, Widget } from '@kunlun/dependencies';
import { exportModelExcelFile } from '@/custom-widget/MindMap/utils/excel';
import { isArray } from 'lodash-es';

@SPI.ClassFactory(
    BaseActionWidget.Token({
        actionType: ActionType.URL,
        name: 'GenerateExcelExport',
        widget: 'UrlAction'
    })
)
export class GenerateExcelExport extends UrlActionWidget {
    public initialize(props: any): this {
        super.initialize({ ...props });
        return this;
    }

    public async clickAction(): Promise<void> {
        try {
            //使用方法 在设计器中拖拽链接动作 配置保留动作 GenerateExcelExport 即可使用
            let  widget = this.getParentWidget() as any;
            while(!(widget instanceof FormSubviewFieldWidget)){
                widget = widget?.getParentWidget?.()
            }
            if(!widget) {
                return
            }
            const value = widget.value??[];
            if (isArray(value)) {
                const model = (widget as any).runtimeSubviewContext ?? this
                exportModelExcelFile(value, model.model, { filename: `${widget.label??''}导出数据${Date.now()}.xlsx` });
            }
            this.refreshCallChaining?.syncCall(false);
        } catch (error) {
            console.log(error);
            
        }
    }
    @Widget.Reactive()
    public get disabled() {
        return false
    }

}
